import { Component, Inject, OnInit } from '@angular/core';
import { InstanceTypes } from '../../../models/instance-types';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from '../../../services/reports.service';
import { map, takeUntil } from 'rxjs/operators';
import { SelectedReports } from '../../../models/reports';
import { downloadFile } from '../../../tools/reports-tools';

@Component({
  selector: 'app-reports-home',
  templateUrl: './client-reports-home.component.html',
  styleUrls: ['./client-reports-home.component.css'],
  standalone: false
})
export class ClientReportsHomeComponent implements OnInit {
  // task 19633 show Recurring Reports by default.
  active = 1;

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }
  public clientCode: string;
  private destroy$ = new Subject<void>();

  constructor(
    public activatedRoute: ActivatedRoute,
    private reportService: ReportsService,
    @Inject('env') private env: any
  ) {}

  ngOnInit() {
    this.activatedRoute.parent.params
      .pipe(
        map(params => {
          return params.client_code;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(x => (this.clientCode = x));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  public download(chosen: SelectedReports) {
    if (chosen == null || chosen.filenames.length === 0) {
      return;
    }
    let mimeType: string = '';
    if (chosen.filenames.length > 1) {
      mimeType = 'application/zip';
    } else {
      mimeType = chosen.filenames[0].mimeType;
    }
    let finalFileName = '';
    if (chosen.filenames.length > 1) {
      finalFileName = `Reports.zip`;
    } else {
      finalFileName = chosen.filenames[0].file;
    }

    this.reportService
      .downloadReports(
        this.clientCode,
        chosen.filenames.map(x => x.id),
        mimeType
      )
      .subscribe(x => {
        const header = x.headers.get('X-Download-Filename');
        const name: string = JSON.parse(header).name;
        downloadFile(x.body, name);
      });
  }
}
